import { useEffect, useState } from 'react';
import { supabase } from '@shared/lib/supabase';

export default function WebhookHealth() {
  const [total, setTotal] = useState(0);
  const [success, setSuccess] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const { data } = await supabase
        .from('callback_attempts')
        .select('success')
        .order('created_at', { ascending: false })
        .limit(20);

      if (data) {
        setTotal(data.length);
        setSuccess(data.filter((d) => d.success).length);
      }
      setLoading(false);
    }
    load();
  }, []);

  if (loading || total === 0) return null;

  const rate = (success / total) * 100;
  const color = rate >= 90 ? 'text-emerald-400' : rate >= 70 ? 'text-amber-400' : 'text-red-400';
  const borderColor = rate >= 90 ? 'border-emerald-500/20' : rate >= 70 ? 'border-amber-500/20' : 'border-red-500/20';
  const bgColor = rate >= 90 ? 'bg-emerald-500/5' : rate >= 70 ? 'bg-amber-500/5' : 'bg-red-500/5';

  return (
    <div className={`border ${borderColor} ${bgColor} rounded px-4 py-3 flex items-center justify-between`}>
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${rate >= 90 ? 'bg-emerald-400' : rate >= 70 ? 'bg-amber-400' : 'bg-red-400'}`} />
        <span
          className="font-mono text-xs"
          style={{ color: 'var(--dash-text-muted)' }}
        >
          Webhooks
        </span>
      </div>
      <span className={`font-mono text-xs ${color}`}>
        {success}/{total} delivered
      </span>
    </div>
  );
}
